import { createI18n } from "vue-i18n";

import common_kor from '@/locales/kor/Common.json';
import etc_kor_new from '@/locales/kor/Etc.json';
import promotionMng_kor from '@/locales/kor/promotionMng/PromotionMng.json';
import agriRentalVehicleData_kor from '@/locales/kor/vehicleMnt/AgriRentalVehicleData.json';
import guideMng_kor from '@/locales/kor/vehicleMnt/GuideMng.json';
import common_eng from '@/locales/eng/Common.json';
import etc_eng from '@/locales/eng/Etc.json';
import promotionMng_eng from '@/locales/eng/promotionMng/PromotionMng.json';
import agriRentalVehicleData_eng from '@/locales/eng/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_eng from '@/locales/eng/gptMng/GptBanMng.json';
import chatData_eng from '@/locales/eng/gptMng/ChatbotData.json';
import guideMng_eng from '@/locales/eng/vehicleMnt/GuideMng.json';
import swMng_eng from '@/locales/eng/swMng/SwManagement.json';
import swMng_kor from '@/locales/kor/swMng/SwManagement.json';


// 프랑스어
import common_fr from '@/locales/fr/Common.json';
import etc_fr from '@/locales/fr/Etc.json';
import promotionMng_fr from '@/locales/fr/promotionMng/PromotionMng.json';
import agriRentalVehicleData_fr from '@/locales/fr/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_fr from '@/locales/fr/gptMng/GptBanMng.json';
import chatData_fr from '@/locales/fr/gptMng/ChatbotData.json';
import guideMng_fr from '@/locales/fr/vehicleMnt/GuideMng.json';

// 스페인어
import common_es from '@/locales/es/Common.json';
import etc_es from '@/locales/es/Etc.json';
import promotionMng_es from '@/locales/es/promotionMng/PromotionMng.json';
import agriRentalVehicleData_es from '@/locales/es/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_es from '@/locales/es/gptMng/GptBanMng.json';
import chatData_es from '@/locales/es/gptMng/ChatbotData.json';
import guideMng_es from '@/locales/es/vehicleMnt/GuideMng.json';

// 독일어
import common_de from '@/locales/de/Common.json';
import etc_de from '@/locales/de/Etc.json';
import promotionMng_de from '@/locales/de/promotionMng/PromotionMng.json';
import agriRentalVehicleData_de from '@/locales/de/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_de from '@/locales/de/gptMng/GptBanMng.json';
import chatData_de from '@/locales/de/gptMng/ChatbotData.json';
import guideMng_de from '@/locales/de/vehicleMnt/GuideMng.json';

// 이탈리아어
import common_it from '@/locales/it/Common.json';
import etc_it from '@/locales/it/Etc.json';
import promotionMng_it from '@/locales/it/promotionMng/PromotionMng.json';
import agriRentalVehicleData_it from '@/locales/it/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_it from '@/locales/it/gptMng/GptBanMng.json';
import chatData_it from '@/locales/it/gptMng/ChatbotData.json';
import guideMng_it from '@/locales/it/vehicleMnt/GuideMng.json';

// 포르투갈어
import common_pt from '@/locales/pt/Common.json';
import etc_pt from '@/locales/pt/Etc.json';
import promotionMng_pt from '@/locales/pt/promotionMng/PromotionMng.json';
import agriRentalVehicleData_pt from '@/locales/pt/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_pt from '@/locales/pt/gptMng/GptBanMng.json';
import chatData_pt from '@/locales/pt/gptMng/ChatbotData.json';
import guideMng_pt from '@/locales/pt/vehicleMnt/GuideMng.json';

// 히브리어
import common_he from '@/locales/he/Common.json';
import etc_he from '@/locales/he/Etc.json';
import promotionMng_he from '@/locales/he/promotionMng/PromotionMng.json';
import agriRentalVehicleData_he from '@/locales/he/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_he from '@/locales/he/gptMng/GptBanMng.json';
import chatData_he from '@/locales/he/gptMng/ChatbotData.json';
import guideMng_he from '@/locales/he/vehicleMnt/GuideMng.json';

// 폴란드어
import common_pl from '@/locales/pl/Common.json';
import etc_pl from '@/locales/pl/Etc.json';
import promotionMng_pl from '@/locales/pl/promotionMng/PromotionMng.json';
import agriRentalVehicleData_pl from '@/locales/pl/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_pl from '@/locales/pl/gptMng/GptBanMng.json';
import chatData_pl from '@/locales/pl/gptMng/ChatbotData.json';
import guideMng_pl from '@/locales/pl/vehicleMnt/GuideMng.json';

// 네덜란드어
import common_nl from '@/locales/nl/Common.json';
import etc_nl from '@/locales/nl/Etc.json';
import promotionMng_nl from '@/locales/nl/promotionMng/PromotionMng.json';
import agriRentalVehicleData_nl from '@/locales/nl/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_nl from '@/locales/nl/gptMng/GptBanMng.json';
import chatData_nl from '@/locales/nl/gptMng/ChatbotData.json';
import guideMng_nl from '@/locales/nl/vehicleMnt/GuideMng.json';

// 체코어
import common_cs from '@/locales/cs/Common.json';
import etc_cs from '@/locales/cs/Etc.json';
import promotionMng_cs from '@/locales/cs/promotionMng/PromotionMng.json';
import agriRentalVehicleData_cs from '@/locales/cs/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_cs from '@/locales/cs/gptMng/GptBanMng.json';
import chatData_cs from '@/locales/cs/gptMng/ChatbotData.json';
import guideMng_cs from '@/locales/cs/vehicleMnt/GuideMng.json';

// 그리스어
import common_el from '@/locales/el/Common.json';
import etc_el from '@/locales/el/Etc.json';
import promotionMng_el from '@/locales/el/promotionMng/PromotionMng.json';
import agriRentalVehicleData_el from '@/locales/el/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_el from '@/locales/el/gptMng/GptBanMng.json';
import chatData_el from '@/locales/el/gptMng/ChatbotData.json';
import guideMng_el from '@/locales/el/vehicleMnt/GuideMng.json';

// 노르웨이어
import common_no from '@/locales/no/Common.json';
import etc_no from '@/locales/no/Etc.json';
import promotionMng_no from '@/locales/no/promotionMng/PromotionMng.json';
import agriRentalVehicleData_no from '@/locales/no/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_no from '@/locales/no/gptMng/GptBanMng.json';
import chatData_no from '@/locales/no/gptMng/ChatbotData.json';
import guideMng_no from '@/locales/no/vehicleMnt/GuideMng.json';

// 덴마크어
import common_da from '@/locales/da/Common.json';
import etc_da from '@/locales/da/Etc.json';
import promotionMng_da from '@/locales/da/promotionMng/PromotionMng.json';
import agriRentalVehicleData_da from '@/locales/da/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_da from '@/locales/da/gptMng/GptBanMng.json';
import chatData_da from '@/locales/da/gptMng/ChatbotData.json';
import guideMng_da from '@/locales/da/vehicleMnt/GuideMng.json';

// 라트비아어
import common_lv from '@/locales/lv/Common.json';
import etc_lv from '@/locales/lv/Etc.json';
import promotionMng_lv from '@/locales/lv/promotionMng/PromotionMng.json';
import agriRentalVehicleData_lv from '@/locales/lv/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_lv from '@/locales/lv/gptMng/GptBanMng.json';
import chatData_lv from '@/locales/lv/gptMng/ChatbotData.json';
import guideMng_lv from '@/locales/lv/vehicleMnt/GuideMng.json';

// 루마니아어
import common_ro from '@/locales/ro/Common.json';
import etc_ro from '@/locales/ro/Etc.json';
import promotionMng_ro from '@/locales/ro/promotionMng/PromotionMng.json';
import agriRentalVehicleData_ro from '@/locales/ro/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_ro from '@/locales/ro/gptMng/GptBanMng.json';
import chatData_ro from '@/locales/ro/gptMng/ChatbotData.json';
import guideMng_ro from '@/locales/ro/vehicleMnt/GuideMng.json';

// 룩셈부르크어
import common_lb from '@/locales/lb/Common.json';
import etc_lb from '@/locales/lb/Etc.json';
import promotionMng_lb from '@/locales/lb/promotionMng/PromotionMng.json';
import agriRentalVehicleData_lb from '@/locales/lb/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_lb from '@/locales/lb/gptMng/GptBanMng.json';
import chatData_lb from '@/locales/lb/gptMng/ChatbotData.json';
import guideMng_lb from '@/locales/lb/vehicleMnt/GuideMng.json';

// 리투아니아어
import common_lt from '@/locales/lt/Common.json';
import etc_lt from '@/locales/lt/Etc.json';
import promotionMng_lt from '@/locales/lt/promotionMng/PromotionMng.json';
import agriRentalVehicleData_lt from '@/locales/lt/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_lt from '@/locales/lt/gptMng/GptBanMng.json';
import chatData_lt from '@/locales/lt/gptMng/ChatbotData.json';
import guideMng_lt from '@/locales/lt/vehicleMnt/GuideMng.json';

// 마케도니아어
import common_mk from '@/locales/mk/Common.json';
import etc_mk from '@/locales/mk/Etc.json';
import promotionMng_mk from '@/locales/mk/promotionMng/PromotionMng.json';
import agriRentalVehicleData_mk from '@/locales/mk/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_mk from '@/locales/mk/gptMng/GptBanMng.json';
import chatData_mk from '@/locales/mk/gptMng/ChatbotData.json';
import guideMng_mk from '@/locales/mk/vehicleMnt/GuideMng.json';

// 몬테네그로어
import common_cnr from '@/locales/cnr/Common.json';
import etc_cnr from '@/locales/cnr/Etc.json';
import promotionMng_cnr from '@/locales/cnr/promotionMng/PromotionMng.json';
import agriRentalVehicleData_cnr from '@/locales/cnr/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_cnr from '@/locales/cnr/gptMng/GptBanMng.json';
import chatData_cnr from '@/locales/cnr/gptMng/ChatbotData.json';
import guideMng_cnr from '@/locales/cnr/vehicleMnt/GuideMng.json';

// 몰타어
import common_mt from '@/locales/mt/Common.json';
import etc_mt from '@/locales/mt/Etc.json';
import promotionMng_mt from '@/locales/mt/promotionMng/PromotionMng.json';
import agriRentalVehicleData_mt from '@/locales/mt/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_mt from '@/locales/mt/gptMng/GptBanMng.json';
import chatData_mt from '@/locales/mt/gptMng/ChatbotData.json';
import guideMng_mt from '@/locales/mt/vehicleMnt/GuideMng.json';

// 보스니아어
import common_bs from '@/locales/bs/Common.json';
import etc_bs from '@/locales/bs/Etc.json';
import promotionMng_bs from '@/locales/bs/promotionMng/PromotionMng.json';
import agriRentalVehicleData_bs from '@/locales/bs/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_bs from '@/locales/bs/gptMng/GptBanMng.json';
import chatData_bs from '@/locales/bs/gptMng/ChatbotData.json';
import guideMng_bs from '@/locales/bs/vehicleMnt/GuideMng.json';

// 불가리아어
import common_bg from '@/locales/bg/Common.json';
import etc_bg from '@/locales/bg/Etc.json';
import promotionMng_bg from '@/locales/bg/promotionMng/PromotionMng.json';
import agriRentalVehicleData_bg from '@/locales/bg/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_bg from '@/locales/bg/gptMng/GptBanMng.json';
import chatData_bg from '@/locales/bg/gptMng/ChatbotData.json';
import guideMng_bg from '@/locales/bg/vehicleMnt/GuideMng.json';

// 세르비아어
import common_sr from '@/locales/sr/Common.json';
import etc_sr from '@/locales/sr/Etc.json';
import promotionMng_sr from '@/locales/sr/promotionMng/PromotionMng.json';
import agriRentalVehicleData_sr from '@/locales/sr/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_sr from '@/locales/sr/gptMng/GptBanMng.json';
import chatData_sr from '@/locales/sr/gptMng/ChatbotData.json';
import guideMng_sr from '@/locales/sr/vehicleMnt/GuideMng.json';

// 핀란드어
import common_fi from '@/locales/fi/Common.json';
import etc_fi from '@/locales/fi/Etc.json';
import promotionMng_fi from '@/locales/fi/promotionMng/PromotionMng.json';
import agriRentalVehicleData_fi from '@/locales/fi/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_fi from '@/locales/fi/gptMng/GptBanMng.json';
import chatData_fi from '@/locales/fi/gptMng/ChatbotData.json';
import guideMng_fi from '@/locales/fi/vehicleMnt/GuideMng.json';

// 스웨덴어
import common_sv from '@/locales/sv/Common.json';
import etc_sv from '@/locales/sv/Etc.json';
import promotionMng_sv from '@/locales/sv/promotionMng/PromotionMng.json';
import agriRentalVehicleData_sv from '@/locales/sv/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_sv from '@/locales/sv/gptMng/GptBanMng.json';
import chatData_sv from '@/locales/sv/gptMng/ChatbotData.json';
import guideMng_sv from '@/locales/sv/vehicleMnt/GuideMng.json';

// 슬로바키아어
import common_sk from '@/locales/sk/Common.json';
import etc_sk from '@/locales/sk/Etc.json';
import promotionMng_sk from '@/locales/sk/promotionMng/PromotionMng.json';
import agriRentalVehicleData_sk from '@/locales/sk/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_sk from '@/locales/sk/gptMng/GptBanMng.json';
import chatData_sk from '@/locales/sk/gptMng/ChatbotData.json';
import guideMng_sk from '@/locales/sk/vehicleMnt/GuideMng.json';

// 슬로베니아어
import common_sl from '@/locales/sl/Common.json';
import etc_sl from '@/locales/sl/Etc.json';
import promotionMng_sl from '@/locales/sl/promotionMng/PromotionMng.json';
import agriRentalVehicleData_sl from '@/locales/sl/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_sl from '@/locales/sl/gptMng/GptBanMng.json';
import chatData_sl from '@/locales/sl/gptMng/ChatbotData.json';
import guideMng_sl from '@/locales/sl/vehicleMnt/GuideMng.json';

// 아랍어
import common_ar from '@/locales/ar/Common.json';
import etc_ar from '@/locales/ar/Etc.json';
import promotionMng_ar from '@/locales/ar/promotionMng/PromotionMng.json';
import agriRentalVehicleData_ar from '@/locales/ar/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_ar from '@/locales/ar/gptMng/GptBanMng.json';
import chatData_ar from '@/locales/ar/gptMng/ChatbotData.json';
import guideMng_ar from '@/locales/ar/vehicleMnt/GuideMng.json';

// 아일랜드어
import common_ga from '@/locales/ga/Common.json';
import etc_ga from '@/locales/ga/Etc.json';
import promotionMng_ga from '@/locales/ga/promotionMng/PromotionMng.json';
import agriRentalVehicleData_ga from '@/locales/ga/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_ga from '@/locales/ga/gptMng/GptBanMng.json';
import chatData_ga from '@/locales/ga/gptMng/ChatbotData.json';
import guideMng_ga from '@/locales/ga/vehicleMnt/GuideMng.json';

// 알바니아어
import common_sq from '@/locales/sq/Common.json';
import etc_sq from '@/locales/sq/Etc.json';
import promotionMng_sq from '@/locales/sq/promotionMng/PromotionMng.json';
import agriRentalVehicleData_sq from '@/locales/sq/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_sq from '@/locales/sq/gptMng/GptBanMng.json';
import chatData_sq from '@/locales/sq/gptMng/ChatbotData.json';
import guideMng_sq from '@/locales/sq/vehicleMnt/GuideMng.json';

// 에스토니아어
import common_et from '@/locales/et/Common.json';
import etc_et from '@/locales/et/Etc.json';
import promotionMng_et from '@/locales/et/promotionMng/PromotionMng.json';
import agriRentalVehicleData_et from '@/locales/et/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_et from '@/locales/et/gptMng/GptBanMng.json';
import chatData_et from '@/locales/et/gptMng/ChatbotData.json';
import guideMng_et from '@/locales/et/vehicleMnt/GuideMng.json';

// 크로아티아어
import common_hr from '@/locales/hr/Common.json';
import etc_hr from '@/locales/hr/Etc.json';
import promotionMng_hr from '@/locales/hr/promotionMng/PromotionMng.json';
import agriRentalVehicleData_hr from '@/locales/hr/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_hr from '@/locales/hr/gptMng/GptBanMng.json';
import chatData_hr from '@/locales/hr/gptMng/ChatbotData.json';
import guideMng_hr from '@/locales/hr/vehicleMnt/GuideMng.json';

// 터키어
import common_tr from '@/locales/tr/Common.json';
import etc_tr from '@/locales/tr/Etc.json';
import promotionMng_tr from '@/locales/tr/promotionMng/PromotionMng.json';
import agriRentalVehicleData_tr from '@/locales/tr/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_tr from '@/locales/tr/gptMng/GptBanMng.json';
import chatData_tr from '@/locales/tr/gptMng/ChatbotData.json';
import guideMng_tr from '@/locales/tr/vehicleMnt/GuideMng.json';

// 헝가리어
import common_hu from '@/locales/hu/Common.json';
import etc_hu from '@/locales/hu/Etc.json';
import promotionMng_hu from '@/locales/hu/promotionMng/PromotionMng.json';
import agriRentalVehicleData_hu from '@/locales/hu/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_hu from '@/locales/hu/gptMng/GptBanMng.json';
import chatData_hu from '@/locales/hu/gptMng/ChatbotData.json';
import guideMng_hu from '@/locales/hu/vehicleMnt/GuideMng.json';

// 아이슬란드어
import common_is from '@/locales/is/Common.json';
import etc_is from '@/locales/is/Etc.json';
import promotionMng_is from '@/locales/is/promotionMng/PromotionMng.json';
import agriRentalVehicleData_is from '@/locales/is/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_is from '@/locales/is/gptMng/GptBanMng.json';
import chatData_is from '@/locales/is/gptMng/ChatbotData.json';
import guideMng_is from '@/locales/is/vehicleMnt/GuideMng.json';
import common_uk from '@/locales/uk/Common.json';
import etc_uk from '@/locales/uk/Etc.json';
import promotionMng_uk from '@/locales/uk/promotionMng/PromotionMng.json';
import agriRentalVehicleData_uk from '@/locales/uk/vehicleMnt/AgriRentalVehicleData.json';
import gptBanMng_uk from '@/locales/uk/gptMng/GptBanMng.json';
import chatData_uk from '@/locales/uk/gptMng/ChatbotData.json';
import guideMng_uk from '@/locales/uk/vehicleMnt/GuideMng.json';


//현재 사용자 브라우저 언어셋 가져오기
const getLanguage = () => {
    let lang = navigator.language || navigator.userLanguage || navigator.systemLanguage || 'en';

    //브라우저 언어가 영어 설정이 아닐때 강제로 언어를 영문으로 요청(추후 언어가 추가되면 수정필요)
    if (!lang.toLowerCase().includes('en')) {
        lang = 'en';
    }

    let langArr = lang.split("-");
    if (langArr.length > 1) {
        lang = langArr[0];
    }

    return lang;
}

const messages = {
    en: {
        ...common_eng,
        ...etc_eng,
        promotionMng: promotionMng_eng,
        ...gptBanMng_eng,
        ...chatData_eng,
        ...agriRentalVehicleData_eng,
        ...guideMng_eng,
        ...swMng_eng
    },
    ko: {
        ...common_kor,
        ...etc_kor_new,
        promotionMng: promotionMng_kor,
        ...agriRentalVehicleData_kor,
        ...guideMng_kor,
        ...swMng_kor
    },
    fr: {
        ...common_fr,
        ...etc_fr,
        promotionMng: promotionMng_fr,
        ...gptBanMng_fr,
        ...chatData_fr,
        ...agriRentalVehicleData_fr,
        ...guideMng_fr
    },
    es: {
        ...common_es,
        ...etc_es,
        promotionMng: promotionMng_es,
        ...gptBanMng_es,
        ...chatData_es,
        ...agriRentalVehicleData_es,
        ...guideMng_es
    },
    de: {
        ...common_de,
        ...etc_de,
        promotionMng: promotionMng_de,
        ...gptBanMng_de,
        ...chatData_de,
        ...agriRentalVehicleData_de,
        ...guideMng_de
    },
    it: {
        ...common_it,
        ...etc_it,
        promotionMng: promotionMng_it,
        ...gptBanMng_it,
        ...chatData_it,
        ...agriRentalVehicleData_it,
        ...guideMng_it
    },
    pt: {
        ...common_pt,
        ...etc_pt,
        promotionMng: promotionMng_pt,
        ...gptBanMng_pt,
        ...chatData_pt,
        ...agriRentalVehicleData_pt,
        ...guideMng_pt
    },
    he: {
        ...common_he,
        ...etc_he,
        promotionMng: promotionMng_he,
        ...gptBanMng_he,
        ...chatData_he,
        ...agriRentalVehicleData_he,
        ...guideMng_he
    },
    pl: {
        ...common_pl,
        ...etc_pl,
        promotionMng: promotionMng_pl,
        ...gptBanMng_pl,
        ...chatData_pl,
        ...agriRentalVehicleData_pl,
        ...guideMng_pl
    },
    nl: {
        ...common_nl,
        ...etc_nl,
        promotionMng: promotionMng_nl,
        ...gptBanMng_nl,
        ...chatData_nl,
        ...agriRentalVehicleData_nl,
        ...guideMng_nl
    },
    cs: {
        ...common_cs,
        ...etc_cs,
        promotionMng: promotionMng_cs,
        ...gptBanMng_cs,
        ...chatData_cs,
        ...agriRentalVehicleData_cs,
        ...guideMng_cs
    },
    el: {
        ...common_el,
        ...etc_el,
        promotionMng: promotionMng_el,
        ...gptBanMng_el,
        ...chatData_el,
        ...agriRentalVehicleData_el,
        ...guideMng_el
    },
    no: {
        ...common_no,
        ...etc_no,
        promotionMng: promotionMng_no,
        ...gptBanMng_no,
        ...chatData_no,
        ...agriRentalVehicleData_no,
        ...guideMng_no
    },
    da: {
        ...common_da,
        ...etc_da,
        promotionMng: promotionMng_da,
        ...gptBanMng_da,
        ...chatData_da,
        ...agriRentalVehicleData_da,
        ...guideMng_da
    },
    lv: {
        ...common_lv,
        ...etc_lv,
        promotionMng: promotionMng_lv,
        ...gptBanMng_lv,
        ...chatData_lv,
        ...agriRentalVehicleData_lv,
        ...guideMng_lv
    },
    ro: {
        ...common_ro,
        ...etc_ro,
        promotionMng: promotionMng_ro,
        ...gptBanMng_ro,
        ...chatData_ro,
        ...agriRentalVehicleData_ro,
        ...guideMng_ro
    },
    lb: {
        ...common_lb,
        ...etc_lb,
        promotionMng: promotionMng_lb,
        ...gptBanMng_lb,
        ...chatData_lb,
        ...agriRentalVehicleData_lb,
        ...guideMng_lb
    },
    lt: {
        ...common_lt,
        ...etc_lt,
        promotionMng: promotionMng_lt,
        ...gptBanMng_lt,
        ...chatData_lt,
        ...agriRentalVehicleData_lt,
        ...guideMng_lt
    },
    mk: {
        ...common_mk,
        ...etc_mk,
        promotionMng: promotionMng_mk,
        ...gptBanMng_mk,
        ...chatData_mk,
        ...agriRentalVehicleData_mk,
        ...guideMng_mk
    },
    cnr: {
        ...common_cnr,
        ...etc_cnr,
        promotionMng: promotionMng_cnr,
        ...gptBanMng_cnr,
        ...chatData_cnr,
        ...agriRentalVehicleData_cnr,
        ...guideMng_cnr
    },
    mt: {
        ...common_mt,
        ...etc_mt,
        promotionMng: promotionMng_mt,
        ...gptBanMng_mt,
        ...chatData_mt,
        ...agriRentalVehicleData_mt,
        ...guideMng_mt
    },
    bs: {
        ...common_bs,
        ...etc_bs,
        promotionMng: promotionMng_bs,
        ...gptBanMng_bs,
        ...chatData_bs,
        ...agriRentalVehicleData_bs,
        ...guideMng_bs
    },
    bg: {
        ...common_bg,
        ...etc_bg,
        promotionMng: promotionMng_bg,
        ...gptBanMng_bg,
        ...chatData_bg,
        ...agriRentalVehicleData_bg,
        ...guideMng_bg
    },
    sr: {
        ...common_sr,
        ...etc_sr,
        promotionMng: promotionMng_sr,
        ...gptBanMng_sr,
        ...chatData_sr,
        ...agriRentalVehicleData_sr,
        ...guideMng_sr
    },
    fi: {
        ...common_fi,
        ...etc_fi,
        promotionMng: promotionMng_fi,
        ...gptBanMng_fi,
        ...chatData_fi,
        ...agriRentalVehicleData_fi,
        ...guideMng_fi
    },
    sv: {
        ...common_sv,
        ...etc_sv,
        promotionMng: promotionMng_sv,
        ...gptBanMng_sv,
        ...chatData_sv,
        ...agriRentalVehicleData_sv,
        ...guideMng_sv
    },
    sk: {
        ...common_sk,
        ...etc_sk,
        promotionMng: promotionMng_sk,
        ...gptBanMng_sk,
        ...chatData_sk,
        ...agriRentalVehicleData_sk,
        ...guideMng_sk
    },
    sl: {
        ...common_sl,
        ...etc_sl,
        promotionMng: promotionMng_sl,
        ...gptBanMng_sl,
        ...chatData_sl,
        ...agriRentalVehicleData_sl,
        ...guideMng_sl
    },
    ar: {
        ...common_ar,
        ...etc_ar,
        promotionMng: promotionMng_ar,
        ...gptBanMng_ar,
        ...chatData_ar,
        ...agriRentalVehicleData_ar,
        ...guideMng_ar
    },
    ga: {
        ...common_ga,
        ...etc_ga,
        promotionMng: promotionMng_ga,
        ...gptBanMng_ga,
        ...chatData_ga,
        ...agriRentalVehicleData_ga,
        ...guideMng_ga
    },
    sq: {
        ...common_sq,
        ...etc_sq,
        promotionMng: promotionMng_sq,
        ...gptBanMng_sq,
        ...chatData_sq,
        ...agriRentalVehicleData_sq,
        ...guideMng_sq
    },
    et: {
        ...common_et,
        ...etc_et,
        promotionMng: promotionMng_et,
        ...gptBanMng_et,
        ...chatData_et,
        ...agriRentalVehicleData_et,
        ...guideMng_et
    },
    hr: {
        ...common_hr,
        ...etc_hr,
        promotionMng: promotionMng_hr,
        ...gptBanMng_hr,
        ...chatData_hr,
        ...agriRentalVehicleData_hr,
        ...guideMng_hr
    },
    tr: {
        ...common_tr,
        ...etc_tr,
        promotionMng: promotionMng_tr,
        ...gptBanMng_tr,
        ...chatData_tr,
        ...agriRentalVehicleData_tr,
        ...guideMng_tr
    },
    hu: {
        ...common_hu,
        ...etc_hu,
        promotionMng: promotionMng_hu,
        ...gptBanMng_hu,
        ...chatData_hu,
        ...agriRentalVehicleData_hu,
        ...guideMng_hu
    },
    is: {
        ...common_is,
        ...etc_is,
        promotionMng: promotionMng_is,
        ...gptBanMng_is,
        ...chatData_is,
        ...agriRentalVehicleData_is,
        ...guideMng_is
    },
    uk: {
        ...common_uk,
        ...etc_uk,
        promotionMng: promotionMng_uk,
        ...gptBanMng_uk,
        ...chatData_uk,
        ...agriRentalVehicleData_uk,
        ...guideMng_uk
    },
};

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    // locale: 'en',
    locale: getLanguage(),
    fallbackLocale: 'en',
    messages,
});

export default i18n;
